<div class="form-group">
  <div [hidden]="!props.template" class="ltv-field" [class]="props.className" [innerHtml]="props.template" aria-live="polite"></div>
  <div class="sr-only">{{ props.abbr }}</div>
</div>
